import { Box } from "@mui/material"
import { styled } from "@mui/system"
import ExhibitorCard from "components/exhibitors/ExhibitorCard"
import { UseFavoriteExhibitorsReturn } from "hooks/exhibitors/useFavoriteExhibitors"
import { ExhibitorChat } from "hooks/useExhibitorChat"
import {
  getExhibitorChatStatus,
  getExhibitorLocation,
  getExhibitorName,
} from "lib/exhibitors/getExhibitorUtils"
import ConventionProviderExhibitor from "models/convention-api/v1/ConventionProviderExhibitor"
import { LinkProps } from "next/link"
import React from "react"

interface ExhibitorCardContainerProps {
  href: LinkProps["href"]
  favoriteExhibitors: UseFavoriteExhibitorsReturn
  exhibitor: ConventionProviderExhibitor
  exhibitorChat: ExhibitorChat
}

export const ExhibitorCardContainer = (props: ExhibitorCardContainerProps) => {
  const { href, favoriteExhibitors, exhibitor, exhibitorChat } = props

  const isFavorite = favoriteExhibitors.isFavorite(exhibitor.id)
  const onFavorite = () => favoriteExhibitors.toggleFavorite(exhibitor.id)

  const chatStatus = getExhibitorChatStatus(exhibitor)
  const exhibitorName = getExhibitorName(exhibitor)
  const location = getExhibitorLocation(exhibitor)

  const isChatEnabled = exhibitorChat.isEnabled && chatStatus !== "off"

  const onChat = () => exhibitorChat.open(exhibitor.institution_id)

  return (
    <ExhibitorCard
      isChatEnabled={isChatEnabled}
      isFavorite={isFavorite}
      onFavorite={onFavorite}
      headerText={exhibitorName}
      subheaderText={location}
      imageSrc={exhibitor.cover_photo_thumb_url}
      href={href}
      onChat={onChat}
    />
  )
}

const _ScrollerContainer = styled(Box)(({ theme }) => ({
  marginRight: theme.spacing(2),
  display: "flex",
  width: 280,
}))

export const ExhibitorCardContainerForScroller = (props: ExhibitorCardContainerProps) => (
  <_ScrollerContainer>
    <ExhibitorCardContainer {...props} />
  </_ScrollerContainer>
)
